import { IsettingRateData } from '../../../types/SettingRateData';
import React, { useEffect, useState } from 'react';
import { useDeviceType } from '../../../hooks/useDeviceType';
import { StarSpans } from './StarSpans';
import { Comment } from './Comment';
import clsx from 'clsx';
import { Text as Paragraph } from 'components/Typography';
import { IRatingData, IRatingMsg } from 'components/Rating/types';
import { Heading } from './Heading';

export interface IRatings {
  ratingData: IRatingData;
  ratingMsg: IRatingMsg;
  settingRateData: IsettingRateData;
  trackingEvent?: (value: number, title: string) => void;
  recipeTitle?: string;
  showCommentField?: boolean;
  showContactPageData?: boolean;
  contactPageData?: string;
}

export const Ratings = ({
  ratingData,
  ratingMsg,
  settingRateData,
  trackingEvent,
  recipeTitle = '',
  showCommentField = false,
  showContactPageData = true,
  contactPageData,
}: IRatings) => {
  // Manages on Hover selection of a star
  const [value, setValue] = useState(0);
  const [dynamicValue, setDynamicValue] = useState(0);
  const [Rating, SetRating] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(true);
  const { isRatingGiven, ratingGiven, setIsRatingGiven, setRatingGiven, comment, setComment } =
    settingRateData;
  const [error, setError] = useState<boolean>(false);
  const [commentRequired, setCommentRequired] = useState<boolean>(false);

  const { isMobile } = useDeviceType();

  useEffect(
    () => () => {
      if (value !== 0 && Rating) {
        setIsRatingGiven(true);
        setRatingGiven(value);
      }
    },
    [value, Rating],
  );

  const handleClick = (newValue: number) => {
    setError(false);
    setCommentRequired(newValue < 3);
    if (!Rating) {
      setDynamicValue(newValue);
      setValue(newValue);
      setDisabled(false);
    }
  };

  const onButtonClick = () => {
    if (showCommentField && commentRequired && comment === '') {
      setError(true);
      return;
    }
    setError(false);
    SetRating(true);
    if (trackingEvent && recipeTitle) {
      trackingEvent(value, recipeTitle);
    }
  };

  return (
    <>
      <div className="md:pt-88 sm:pt-70 md:px-155 sm:px-22">
        <Heading
          isRatingGiven={isRatingGiven}
          Rating={Rating}
          ratingMsg={ratingMsg}
          ratingData={ratingData}
        />
        <StarSpans
          value={value}
          isRatingGiven={isRatingGiven}
          ratingGiven={ratingGiven}
          handleClick={handleClick}
          ratingMsg={ratingMsg}
          dynamicValue={dynamicValue}
          setDynamicValue={setDynamicValue}
          Rating={Rating}
        />

        <Comment
          showCommentField={showCommentField}
          ratingData={ratingData}
          commentRequired={commentRequired}
          comment={comment}
          Rating={Rating}
          isRatingGiven={isRatingGiven}
          setComment={(value) => {
            setComment(value);
          }}
          error={error}
        />
      </div>
      {!Rating && !isRatingGiven && (
        <button
          onClick={onButtonClick}
          disabled={disabled}
          className={clsx(
            `text-white rounded-[26px] bg-dark-brown relative flex items-center justify-center m-auto disabled:opacity-50 before:content-[''] before:absolute before:border before:border-white before:w-[calc(100%-12px)] before:top-1.5 before:left-1.5 before:rounded-[20px]`,
            isMobile
              ? `mt-3.5 h-[50px] w-[157px] before:h-[38px]`
              : `mb-6 h-[52px] w-[183px] before:h-10`,
          )}
        >
          <Paragraph tag="div" type="lead">
            {ratingMsg?.ratingBtn}
          </Paragraph>
        </button>
      )}
      {showContactPageData && (
        <div
          className="mb-[25px] [&_a]:underline"
          dangerouslySetInnerHTML={{ __html: contactPageData || `` }}
        />
      )}
    </>
  );
};
